/**
 * DIY tab switcher. Interaction-critical — keep this file small.
 */
(function () {
  function init(root) {
    if (!root || root.dataset.amcDiyReady === 'true') return;
    root.dataset.amcDiyReady = 'true';

    var tabs = root.querySelectorAll('[data-amc-diy-tab]');
    var panels = root.querySelectorAll('.amc-diy__panel');
    var views = root.querySelectorAll('[data-amc-diy-view]');
    var current = null;
    var warmed = {};

    function panelFor(key) {
      for (var i = 0; i < panels.length; i++) {
        if (String(panels[i].getAttribute('data-index')) === key) return panels[i];
      }
      return null;
    }

    function warmPanel(key) {
      if (warmed[key]) return;
      var panel = panelFor(key);
      if (!panel) return;
      warmed[key] = true;
      var imgs = panel.querySelectorAll('img');
      for (var i = 0; i < imgs.length; i++) {
        var img = imgs[i];
        img.setAttribute('loading', 'eager');
        var src = img.currentSrc || img.getAttribute('src');
        if (!src) continue;
        var pre = new Image();
        pre.decoding = 'async';
        pre.src = src;
      }
    }

    function setTab(index) {
      var key = String(index);
      if (current === key) return;
      current = key;

      var i;
      for (i = 0; i < tabs.length; i++) {
        var tabOn = tabs[i].getAttribute('data-amc-diy-tab') === key;
        tabs[i].classList.toggle('is-active', tabOn);
        tabs[i].setAttribute('aria-selected', tabOn ? 'true' : 'false');
        tabs[i].tabIndex = tabOn ? 0 : -1;
      }

      for (i = 0; i < panels.length; i++) {
        var panelOn = String(panels[i].getAttribute('data-index')) === key;
        panels[i].classList.toggle('is-active', panelOn);
        panels[i].classList.toggle('is-hidden', !panelOn);
        if (panelOn) {
          panels[i].removeAttribute('hidden');
          warmPanel(key);
        } else {
          panels[i].setAttribute('hidden', '');
        }
      }

      for (i = 0; i < views.length; i++) {
        views[i].classList.toggle('is-active', views[i].getAttribute('data-amc-diy-view') === key);
      }
    }

    function tabFromEvent(event) {
      var node = event.target;
      if (!node || !node.closest) return null;
      var tab = node.closest('[data-amc-diy-tab]');
      return tab && root.contains(tab) ? tab : null;
    }

    function activateFromEvent(event) {
      var tab = tabFromEvent(event);
      if (!tab) return false;
      setTab(tab.getAttribute('data-amc-diy-tab'));
      return true;
    }

    var tabDrag = { x: 0, active: false, moved: false };
    var tablist = root.querySelector('.amc-diy__tabs') || root;
    tablist.addEventListener(
      'pointerdown',
      function (event) {
        if (event.button != null && event.button !== 0) return;
        tabDrag.x = event.clientX;
        tabDrag.active = true;
        tabDrag.moved = false;
      },
      { passive: true }
    );
    tablist.addEventListener(
      'pointermove',
      function (event) {
        if (!tabDrag.active) return;
        if (Math.abs(event.clientX - tabDrag.x) > 8) tabDrag.moved = true;
      },
      { passive: true }
    );
    tablist.addEventListener(
      'pointerup',
      function () {
        tabDrag.active = false;
      },
      { passive: true }
    );
    tablist.addEventListener(
      'pointercancel',
      function () {
        tabDrag.active = false;
        tabDrag.moved = true;
      },
      { passive: true }
    );

    root.addEventListener('click', function (event) {
      if (tabDrag.moved) {
        tabDrag.moved = false;
        event.preventDefault();
        return;
      }
      if (!activateFromEvent(event)) return;
      event.preventDefault();
    });

    var t;
    for (t = 0; t < tabs.length; t++) {
      tabs[t].addEventListener('pointerenter', function () {
        warmPanel(this.getAttribute('data-amc-diy-tab'));
      });
      tabs[t].addEventListener('focus', function () {
        warmPanel(this.getAttribute('data-amc-diy-tab'));
      });
    }

    root.addEventListener(
      'pointerover',
      function (event) {
        var link = event.target.closest && event.target.closest('a.amc-diy-card__media, a.amc-diy-card__title');
        if (!link || !root.contains(link) || !link.href) return;
        if (link.getAttribute('data-amc-diy-prefetched') === '1') return;
        link.setAttribute('data-amc-diy-prefetched', '1');
        var prefetch = document.createElement('link');
        prefetch.rel = 'prefetch';
        prefetch.href = link.href;
        document.head.appendChild(prefetch);
      },
      { passive: true }
    );

    root.addEventListener('keydown', function (event) {
      if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft' && event.key !== 'Home' && event.key !== 'End') {
        return;
      }
      var tab = tabFromEvent(event);
      if (!tab) return;
      event.preventDefault();
      var list = Array.prototype.slice.call(tabs);
      var index = list.indexOf(tab);
      if (index < 0) return;
      var next = index;
      if (event.key === 'ArrowRight') next = (index + 1) % list.length;
      else if (event.key === 'ArrowLeft') next = (index - 1 + list.length) % list.length;
      else if (event.key === 'Home') next = 0;
      else next = list.length - 1;
      list[next].focus();
      setTab(list[next].getAttribute('data-amc-diy-tab'));
    });

    var initial = '0';
    for (t = 0; t < tabs.length; t++) {
      if (tabs[t].classList.contains('is-active')) {
        initial = tabs[t].getAttribute('data-amc-diy-tab') || '0';
        break;
      }
    }
    current = null;
    setTab(initial);

    var idle = window.requestIdleCallback || function (cb) { return setTimeout(cb, 350); };
    idle(function () {
      for (var p = 0; p < panels.length; p++) {
        warmPanel(String(panels[p].getAttribute('data-index')));
      }
    });
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-section-type="amc-diy-section"]').forEach(init);
  }

  boot();
  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();
